// extracted by mini-css-extract-plugin
export default {"container":"src-styles-bio-__bio_desc__container__3HICf","techContainer":"src-styles-bio-__bio_desc__techContainer__13aVi"};